import React from 'react';

const EMOJIS = [
  '😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😎', '🤩', '🤔',
  '😅', '😇', '🙂', '🙃', '😋', '😌', '😜', '🤗', '🤐', '😴',
  '👍', '👎', '👏', '🙌', '🙏', '💪', '🤝', '👌', '✌️', '🤞',
  '❤️', '💔', '💯', '🔥', '✨', '⭐', '🎉', '🎊', '🎁', '🎂',
  '✅', '❌', '⚠️', '⏰', '📌', '📍', '📞', '📧', '💬', '📝',
  '💰', '💵', '💳', '🏦', '🏠', '🏢', '🏨', '🛏️', '🛎️', '🔑',
];

const EmojiPicker = ({ onPick, onClose }) => (
  <div
    className="absolute bottom-14 left-2 z-40 w-72 rounded-xl border border-gray-200 bg-white shadow-2xl p-2"
    data-testid="inbox-emoji-picker"
  >
    <div className="px-2 py-1 text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Emoji</div>
    <div className="grid grid-cols-10 gap-1 max-h-60 overflow-y-auto">
      {EMOJIS.map((e) => (
        <button
          key={e}
          type="button"
          onClick={() => { onPick(e); onClose?.(); }}
          className="text-xl leading-none w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors"
          data-testid={`emoji-${e}`}
        >
          {e}
        </button>
      ))}
    </div>
  </div>
);

export default EmojiPicker;
